import Icon from '@material-ui/core/Icon';
import { MyTableCol, MyTableRow } from 'components/MyTable';
import { WithStyles } from 'decorators/withStyles';
import moment from 'moment';
import React, { PureComponent } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { showDetails } from 'store/Orbita/FiscalDocuments/actions';

import type { ICDFList } from 'store/Orbita/FiscalDocuments/interfaces';

interface IPropsFromConnect {
  showDetails?: typeof showDetails;
}

interface IProps {
  data: ICDFList[0]['list'][0];
  classes?: any;
}

@WithStyles({
  tdAction: {
    textAlign: 'right',
    width: 50,
    paddingRight: '12px !important',
    cursor: 'pointer',
  },
})
class TableSubItem extends PureComponent<IProps & IPropsFromConnect, {}> {
  openDetails = () => {
    this.props.showDetails(this.props.data);
  };

  render() {
    const { data, classes } = this.props;

    return (
      <MyTableRow>
        <MyTableCol>{moment(data.reference_date).format('DD/MM/YYYY')}</MyTableCol>
        <MyTableCol>{data.id}</MyTableCol>
        <MyTableCol>{data.status}</MyTableCol>
        <MyTableCol>{data.display}</MyTableCol>
        <MyTableCol numeric>
          <FormattedNumber value={data.value} format='BRL' />
        </MyTableCol>
        <MyTableCol onClick={this.openDetails} className={classes.tdAction}>
          <Icon>more_horiz</Icon>
        </MyTableCol>
      </MyTableRow>
    );
  }
}

export default connect<IPropsFromConnect, {}, IProps>(() => ({}), { showDetails })(TableSubItem);
